/* eslint-disable no-mixed-operators */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */

import React, { useState, useEffect, useContext } from 'react';
import Modal from 'react-modal';
import { CDN } from '../../constants';
import HeaderContext from '../Context/HeaderContext';
import { WishlistExist } from '../../redux/helper/AddWishlist';
import { CartPayload } from '../../redux/helper/CartPayloadGenerator';
import { distributorService } from '../../service/distributor.service';
import ThreeDotsLoader from '../LoadingDots';

export default function AddToCart({
    product, isClose, handlefetch, Cart, OrderDetails, defaultAddress,
}) {
    const [quantity, setquantity] = useState();
    const [removePopup, setremovePopup] = useState('');
    const { SetSuccessMessage } = useContext(HeaderContext);
    const handleProductCount = () => {
        let count = (product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b') ? 1 : product?.MINIMUM_ORDER_QUANTITY || 1);
        if (WishlistExist(Cart, product.INVENTORY_ITEM_ID)) {
            let indx = -1;
            Cart.map((val, i) => {
                if (indx === -1) {
                    if (val.INVENTORY_ITEM_ID === product.INVENTORY_ITEM_ID) {
                        indx = i;
                    }
                }
            });
            count = indx > -1 ? Cart[indx].quantity : count;
        }
        return count;
    };
    const [loading, setloading] = useState(false);
    useEffect(() => {
        setquantity(handleProductCount());
    }, [product]);

    const [quantityError, setquantityError] = useState(false);

    const handleConfirm = async () => {
        setloading(true);
        const payload = CartPayload(product, quantity);
        payload.SHIPPING_ADDRESS = defaultAddress.shipping_address;
        payload.BILLING_ADDRESS = defaultAddress.billing_address;
        const { items, instruction } = OrderDetails;
        const category = Object.keys(items).length > 0 ? Object.keys(items)[0] : instruction;
        if (items[category] === undefined) {
            items[category] = [payload];
        } else {
            items[category].push(payload);
        }
        const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!res.error && res.data.success_status) {
            isClose({});
            handlefetch();
            setquantityError(false);
            setloading(false);
            SetSuccessMessage('Product added to cart');
            setTimeout(() => {
                SetSuccessMessage('');
            }, 2000);
        } else if (res?.message?.response?.data?.special_offer_exist) {
            setremovePopup('active');
            setloading(false);
        } else {
            setloading(false);
        }
    };

    const handleCheck = (copy) => {
        setquantityError(false);
        if (!product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b')) {
            if ((Math.round(copy * 10000) % Math.round((product?.PACKING_SIZE || 1) * 10000) !== 0)) {
                setquantityError(true);
            }
        } else if (copy < 1) {
            setquantityError(true);
        }
    };
    function nearest(n, x) {
        const u = n % x >= x / 2;
        return n + (-1) ** (1 - u) * Math.abs(x * u - n % x);
    }
    const handleQuantity = (type, quantity) => {
        let copy = Number(quantity);
        if (type === '+') {
            copy = nearest(copy, ((product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(product?.PACKING_SIZE) || 1)));
            if (Number(quantity) === (Number(copy))) {
                copy += (product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(product.PACKING_SIZE) || 1);
            }
            if (!Number.isInteger(quantity)) {
                copy = copy.toFixed(2);
                setquantity(copy);
            } else {
                setquantity(copy);
            }
        }
        if (type === '-') {
            if (copy - (product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b') ? 1 : product.PACKING_SIZE) >= (product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b') ? 1 : product?.MINIMUM_ORDER_QUANTITY)) {
                if (Math.abs(copy % Number(product?.PACKING_SIZE) || 1) < 0.0001) {
                    copy = nearest(copy, ((product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(product?.PACKING_SIZE) || 1)));
                } else {
                    copy -= (product?.PRODUCT_UOM_CODE?.toLowerCase().includes('b') ? 1 : Number(product.PACKING_SIZE) || 1);
                }
                if (!Number.isInteger(quantity)) {
                    copy = copy.toFixed(2);
                    setquantity(copy);
                } else {
                    setquantity(copy);
                }
            }
        }
        handleCheck(copy);
    };

    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');
    return (
        <Modal
            style={{ overFlow: 'auto' }}
            isOpen={Object.keys(product).length > 0 && removePopup === ''}
        >
            <div className="modal-dialog modal-dialog-centered relative pointer-events-none sm:max-w-[444px] w-auto px-2" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md px-10">
                        <h5 className="sm:text-lg text-base font-semibold text-[#090406] text-center w-full border-b border-[#707070] lg:pb-[18px] pb-3.5" id="exampleModalScrollableLabel1">
                            Add to Cart
                        </h5>
                        <button
                            type="button"
                            onClick={() => {
                                isClose({});
                                setquantityError(false);
                            }}
                            className="absolute top-4 right-5"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <img src="/images/Icon-ionic-ios-close.svg" alt="" />
                        </button>
                    </div>
                    <div className="modal-body relative px-10 pt-[18px] text-center">
                        <div className="flex justify-center">
                            <img src={handleImage(product?.IMAGE_NAME)} alt="icon" style={{ height: '104px', width: '137px', objetFit: 'cover' }} />
                        </div>
                        <p className="lg:text-xs4 md:text-lg text-base font-bold text-[#090406] text-center lg:pt-3.5 pt-1">{product?.MODEL_DESCRIPTION || `${product?.DESCRIPTION?.length > 20 ? `${product.DESCRIPTION.slice(0, 20)}...` : `${product.DESCRIPTION}`}`}</p>
                        <p className="text-xs font-normal text-[#808285] pt-0.5">
                            Product Code:
                            {' '}
                            {product.CONCATENATED_SEGMENTS}
                            {' '}
                            | AWS Classification:
                            {' '}
                            {product.AWS_CLASSIFICATION}
                        </p>
                    </div>
                    <div className="pt-4">
                        <p className="text-xs6 font-semibold text-[#808285] text-center">Set Quantity</p>
                        <div className="flex justify-center pt-2 items-center">
                            <img src="/images/Group8502.png" alt="icon" className={`${quantity > 1 ? 'cursor-pointer' : 'pointer-events-none'}`} onClick={() => handleQuantity('-', quantity)} />
                            <input
                                value={quantity}
                                type="text"
                                pattern="\d.*"
                                onChange={(e) => {
                                    setquantity(e.target.value);
                                    handleCheck(e.target.value);
                                }}
                                maxLength="11"
                                onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                className="sm:w-[110px] w-13 h-7 border border-[#808285] rounded-lg outline-0 text-center sm:px-2 px-1 sm:text-xs9 text-xs6 font-semibold text-[#090406] mx-2"
                            />
                            <p className="text-base font-semibold text-[#090406] self-end mr-2">{product?.PRODUCT_UOM_CODE}</p>
                            <img src="/images/Group8503.png" alt="icon" className="cursor-pointer" onClick={() => handleQuantity('+', quantity)} />
                        </div>
                        {quantityError && (
                            <p className="text-xs3 font-normal text-[#ED1C24] pt-2 flex justify-center items-center">
                                <span>
                                    <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer pr-1" />
                                </span>
                                Quantity should be based on the MOQ and Standard Pack Size
                            </p>
                        )}
                        <div className="md:px-16 sm:px-10 px-5 lg:pt-[22px] pt-3">
                            <div className="flex items-center justify-between">
                                <p className="lg:text-xl sm:text-base text-sm font-semibold text-[#808285] pr-1">List Price</p>
                                <p className="lg:text-xs11 sm:text-lg text-base font-semibold text-[#15090E]">
                                    {Number(product?.LIST_PRICE).toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })}

                                </p>
                            </div>
                            <div className="flex items-center justify-between md:pt-2 pt-1">
                                <p className="lg:text-xl sm:text-base text-sm font-semibold text-[#808285] pr-1">Amount</p>
                                <p className="lg:text-xs11 sm:text-lg text-base font-semibold text-[#15090E]">
                                    {(product?.LIST_PRICE * quantity).toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })}

                                </p>
                            </div>
                        </div>
                        <div className="flex justify-center sm:pt-[33px] pt-6 pb-[18px]">
                            <button
                                type="buton"
                                onClick={() => {
                                    handleConfirm();
                                }}
                                disabled={quantityError || quantity <= 0}
                                className="bg-[#555259] flex justify-center items-center rounded-lg md:w-[284px] w-[200px] md:h-10 h-8 text-sm font-semibold text-[#FFFFFF] cart-add"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                { loading ? <ThreeDotsLoader /> : 'Confirm'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
